import { i18n } from '@/components/i18n.js'

const messages = {
  _default: (field) => `The ${field} value is not valid.`,
  email: (field) => i18n.tc('validationMessageEmail'),
  required: (field) => i18n.tc('validationMessageRequired')
}

var getAttributeNames = function () {
  var attributeList = {}
  var attributes = [ 'customerTitle', 'customerFirstname', 'customerLastname', 'customerEmail', 'visitFrom', 'visitTo', 'visitRoom' ]
  for (var index in attributes) {
    var attribute = attributes[index]
    attributeList[attribute] = i18n.tc(attribute)
  }
  return attributeList
}

const attributes = getAttributeNames()

const locale = {
  messages,
  attributes
}

export default locale



// WEBPACK FOOTER //
// ./src/languages/test.js